"use client";
import { createContext, useContext } from "react";

// Create i18n context object
const StripePublishableKeyContext = createContext<string>("");

export const useStripePublishableKey = () =>
  useContext(StripePublishableKeyContext);

export const StripePublishableKeyProvider = ({
  children,
  stripePublishableKey,
}: {
  children: React.ReactNode;
  stripePublishableKey: string;
}) => (
  <StripePublishableKeyContext.Provider value={stripePublishableKey}>
    {children}
  </StripePublishableKeyContext.Provider>
);
